module.exports = __webpack_public_path__ + "img/aicad-team-united.abf53786.jpg";